import React, { useState, useEffect } from "react";
import { Button, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios"; // 🔁 axios personnalisé avec X-Tenant

// Fonction pour formater la date
const formatDate = (isoString) => {
  if (!isoString) return "Unknown";
  const date = new Date(isoString);
  return date
    .toLocaleString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(",", "");
};

const Budgets = () => {
  const navigate = useNavigate();
  const [budgets, setBudgets] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBudgets = async () => {
      setLoading(true);
      try {
        const response = await api.get("/quickbooks/budgets/");
        const rawBudgets = response.data.budgets || [];

        const formattedBudgets = rawBudgets.map((budget) => ({
          name: budget.Name || "Unnamed Budget",
          type: budget.BudgetType || "N/A",
          lastModified: `${formatDate(budget.MetaData?.LastUpdatedTime)}`,
          actions: (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => navigate(`/budgets/edit?name=${encodeURIComponent(budget.Name)}`)}
            >
              Edit
            </Button>
          ),
        }));

        setBudgets(formattedBudgets);
      } catch (err) {
        console.error("Failed to fetch budgets:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBudgets();
  }, []);

  const columns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Type", accessor: "type", align: "left" },
    { Header: "Last Modified", accessor: "lastModified", align: "left" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="flex-end" mb={2}>
          <Button variant="contained" color="primary">
            Add Budget
          </Button>
        </Grid>
        <MDBox pt={3}>
          <DataTable table={{ columns, rows: budgets }} isLoading={loading} noEndBorder />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Budgets;
